<div class="flex flex-row justify-center items-center">
  <mat-card class="w-1/2 mt-8" [ngClass]="{
        'bg-gray-700': settings.theme === 'dark',
        'bg-indigo-50': settings.theme === 'light'}">
    <!-- <mat-card-title>
      <span style="font-size: larger">Login / Register</span>
    </mat-card-title> -->
    <mat-card-content>

<div *ngIf="!loggingIn" class="flex flex-col sm:justify-start sm:items-center gap-4">
  <!-- B2C Login options -->
  <div class="flex flex-col md:flex-row gap-6 sm:gap-40" *ngIf="isB2C()">

    <div class="flex flex-col gap-2 justify-start items-center">
      <span style="font-size: x-large;"> 
        <h1><strong>ORELAP Login / Registration</strong></h1>
      </span>
      <!-- <span style="font-size: x-large;"> <strong>Login / Register New Account</strong> </span> -->
      <button mat-raised-button (click)="login()" color="primary">Login</button>
    </div>

  </div>

</div>

    </mat-card-content>
  </mat-card>
</div>
